module.exports = __webpack_public_path__ + "img/fs-icon.8a145305.svg";